export default __webpack_public_path__ + "static/media/phone.309a1d13.svg";